import {
  getAllAffiliations,
  getAffiliationSubgroups,
  getAffiliationByID,
  getAffiliationIDBySubgroupID
} from './affiliationsHelpers';

/**
 * Function to return the list for selecting secondary contributors which
 * includes all affiliations by full name but omit given affiliation id.
 * Used in GCI
 * @param {object} affiliationsData
 * @param {string} affiliationId - to be omitted affiliation id
 * @returns {Array} - Array of objects of affiliation IDs and full names
**/
export function getSecondaryContributorsList(affiliationsData, affiliationId) {
  const affiliationsList = getAllAffiliations(affiliationsData);
  const parsedAffiliations = [];

  if (affiliationsList) {
    affiliationsList.forEach(affiliation => {
      // Remove given affiliation from list
      if (!affiliationId ||
          (affiliationId && affiliation?.id !== affiliationId)) {
        parsedAffiliations.push({
          value: affiliation?.id,
          label: `${affiliation?.fullName} (${affiliation?.id})`
        });
      }
    });
    parsedAffiliations.sort((first, second) => first.label.localeCompare(second.label));
  }

  return parsedAffiliations;
}

/**
 * Function to return the list for selectiong secondary approvers which
 * includes all affiliation subgroups from all affiliations but omit GCEP
 * from given affiliation id.
 * Used in GCI
 * @param {object} affiliationsData
 * @param {string} affiliationId - to be omitted affiliation id
 * @returns {Array} - Array of objects of affiliation subgroup IDs and names
 */
export function getSecondaryApproversList(affiliationsData, affiliationId) {
  const parsedApprovers = [];
  const approverList = getAffiliationSubgroups(affiliationsData);
     
  if (approverList) {
    const affilData = affiliationId
      ? getAffiliationByID(affiliationId, affiliationsData)
      : null;

    approverList.forEach(approver => {
      // If affiliation has GCEP
      if (approver?.gcep?.id) {
        // Add to list if not GCEP of given affiliation
        if (!affilData ||
            (affilData &&
             approver.gcep.id !== affilData.subgroups?.gcep?.id)) {
          parsedApprovers.push({
            value: approver.gcep.id,
            label: approver.gcep.fullname
          });
        }
      }
      // If affiliation has VCEP, add to list
      if (approver?.vcep?.id) {
        parsedApprovers.push({
          value: approver.vcep.id,
          label: approver.vcep.fullname
        });
      }
    });
    parsedApprovers.sort((first, second) => first.label.localeCompare(second.label));
  }

  return parsedApprovers;
}

/**
 * Function to validate given approver's affiliation is not the same
 * affiliation as one of the contributor in given contributorsList
 * @param {object} affiliationsData
 * @param {Array} contributorsList - list of affiliation id
 * @param {string} approver - affiliation subgroup id 
 * @returns {boolean} - true or false
 */
export function validateSecondaryContributors(affiliationsData, contributorsList, approver) {
  // An affiliation cannot be both secondary contributor and approver
  // If there's selected contributor(s) and approver, check them
  // The approver value can be "none" if from approval panel
  // and "None" from republish modal so check both
  if (contributorsList?.length && approver &&
      approver !== 'none' && approver !== 'None') {
    // Get the affiliation ID for given approver
    const approverAffilId = getAffiliationIDBySubgroupID(approver, affiliationsData);
    // If secondary approver GCEP/VCEP is already selected as classification contributor then error
    if (contributorsList.includes(approverAffilId)) {
      return false;
    }
  }
  return true;
}

